module.exports = __webpack_public_path__ + "static/media/app.9c1f1e9e.png";